<template>
  <!-- The row menu of the passkeys dialog's table: the app's kebab, as every
       other table row has, rather than inline icon buttons. -->
  <!-- open-rightward: "Rename…" makes this menu wide enough that the default
       placement opens it with the pointer on that caption. -->
  <ActionMenu :disabled="disabled" open-rightward>
    <AppMenuItem icon="mdi-pencil-outline" icon-color="grey" @click="rename()">
      Rename…
    </AppMenuItem>
    <AppMenuItem icon="mdi-delete" icon-color="grey" @click="remove()">
      Delete
    </AppMenuItem>
  </ActionMenu>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import type { IPasskey } from '~/types/passkey/models'

const mn = '[components/passkeys/PasskeyMenu.vue]'

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<IPasskey>,
      required: true,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: ['rename', 'delete'],
  methods: {
    rename() {
      console.debug(`${mn} MENU OPTION SELECTED: RENAME`)
      this.$emit('rename', this.item)
    },
    remove() {
      console.debug(`${mn} MENU OPTION SELECTED: DELETE`)
      this.$emit('delete', this.item)
    },
  },
})
</script>
